import React from 'react';
import { connect } from 'react-redux';

import classes from './PaymentNavigation.scss';
import Media from 'react-media';

import creditCardImage from '../../../assets/images/payments/card-filled.svg';

import * as uiActions from '../../../store/actions/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const paymentNavigation = (props) => {
    const paymentOptions = Object.keys(props.paymentOptions).map(i => props.paymentOptions[i]);
    let sortedPaymentOptions = paymentOptions.sort((a, b) => {
        return parseInt(a.priority, 10) - parseInt(b.priority, 10);
    })
    return (
        <nav className={classes.Nav}>
            {   
                !props.paymentOptionsMobile ? 
                <ul className={`${classes.NavList} u-phoneShow`}>
                    {sortedPaymentOptions.map((paymentOption) => {
                        return ( <li 
                                key={paymentOption.code} 
                                className={classes.NavItem} 
                                onClick={() => { 
                                    props.onTogglePaymentsOptionMobile(true)
                                    props.onSetPaymentMode(paymentOption.code)
                                }}>
                                <img className={classes.NavImage} src={creditCardImage} alt='Credit/Debit Card'/>
                                <span className={classes.Tag}></span>{paymentOption.displayText}
                            </li>
                        );
                    })}
                </ul> : null
            } 
            <Media query="(max-width: 599px)">
                {matches => 
                    matches ? 
                    props.paymentOptionsMobile ? 
                    <ul className={classes.NavList}>
                        {sortedPaymentOptions.map((paymentOption) => {
                        return ( <li 
                                style={{ display: props.paymentMode === paymentOption.code ? 'block' : 'none' }}
                                key={paymentOption.code} 
                                className={[classes.NavItem, props.paymentMode === paymentOption.code ? classes.NavItemActive : null].join(' ')} 
                                onClick={() => props.onSetPaymentMode(paymentOption.code)}>
                                <span className={`u-absolute u-left0 ml-4`} onClick={() => props.onTogglePaymentsOptionMobile(false)}><FontAwesomeIcon icon="times" color="#666" size="sm" /></span>
                                <img className={classes.NavImage} src={creditCardImage} alt='Credit/Debit Card'/>
                                <span className={classes.Tag}></span>{paymentOption.displayText}
                            </li> )
                            })}
                    </ul> : null
                    : 
                    <ul className={classes.NavList}>
                        {sortedPaymentOptions.map((paymentOption) => {
                        return ( <li     
                                key={paymentOption.code} 
                                className={[classes.NavItem, props.paymentMode === paymentOption.code ? classes.NavItemActive : null].join(' ')} 
                                onClick={() => props.onSetPaymentMode(paymentOption.code)}>
                                <img className={classes.NavImage} src={creditCardImage} alt='Credit/Debit Card'/>
                                <span className={classes.Tag}></span>{paymentOption.displayText}
                            </li> )
                        })}
                    </ul>
                }
            </Media>
        </nav>
    );
}

const mapStateToProps = state => {
    return {
        paymentMode: state.ui.paymentMode,
        paymentOptions: state.payments.paymentOptions,
        paymentOptionsMobile: state.ui.paymentOptionsMobile
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetPaymentMode: (mode) => dispatch(uiActions.setPaymentMode(mode)),
        onTogglePaymentsOptionMobile: (val) => dispatch(uiActions.togglePaymentOptionsMobile(val))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(paymentNavigation);


// WEBPACK FOOTER //
// ./src/components/Payment/PaymentNavigation/PaymentNavigation.js